module.exports = __webpack_public_path__ + "static/img/02@2x.5bcc541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/02@2x.png
// module id = k6vu
// module chunks = 1